import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { logout } from "app/pages/Auth/AuthActions";
import { fetchCoupons } from "app/pages/Account/MyCoupons/couponActionCreators";
import {
	getAvailableCreditNotesTotal,
	getAvailableCreditsTotal,
	hasAnyCreditNotes,
} from "app/pages/Account/MyCoupons/couponSelector";
import { getMyBookingsCustomerRequestsCount } from "app/pages/Account/MyBookings/myBookingsSelector";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import { brandPropTypes } from "app/utils/propTypes";
import AccountAsideMenuAuthenticated from "app/pages/Account/AccountAsideMenu/AccountAsideMenuAuthenticated";

const AccountAsideMenuAuthenticatedContainer = ({
	fetchCoupons = () => {},
	brand,
	enableSponsorship = false,
	enableCredits = false,
	enableCreditNotes = false,
	partnerCode,
	totalCredit,
	totalCreditNote,
	shouldDisplayCreditNotesEntry = false,
	myBookingsCustomerRequestCount,
	userIsConnected = false,
	logout = () => {},
	showSmartDPOnRootUrl = false,
}) => {
	useEffect(() => {
		if (enableCredits || enableCreditNotes) {
			fetchCoupons();
		}
	}, [enableCredits, enableCreditNotes]);

	return (
		<AccountAsideMenuAuthenticated
			enableSponsorship={enableSponsorship}
			enableCredits={enableCredits}
			brand={brand}
			partnerCode={partnerCode}
			creditsAmount={totalCredit}
			creditNotesAmount={totalCreditNote}
			shouldDisplayCreditNotesEntry={shouldDisplayCreditNotesEntry}
			showCustomerRequestNotification={myBookingsCustomerRequestCount > 0}
			userIsConnected={userIsConnected}
			showSmartDPOnRootUrl={showSmartDPOnRootUrl}
			logout={logout}
		/>
	);
};

AccountAsideMenuAuthenticatedContainer.propTypes = {
	enableCredits: PropTypes.bool,
	enableCreditNotes: PropTypes.bool,
	enableSponsorship: PropTypes.bool,
	userIsConnected: PropTypes.bool,
	showSmartDPOnRootUrl: PropTypes.bool,
	fetchCoupons: PropTypes.func,
	logout: PropTypes.func,
	brand: brandPropTypes,
	shouldDisplayCreditNotesEntry: PropTypes.bool,
	partnerCode: PropTypes.string,
	totalCredit: PropTypes.number,
	totalCreditNote: PropTypes.number,
	myBookingsCustomerRequestCount: PropTypes.number,
};

const mapDispatchToProps = dispatch => bindActionCreators({ logout, fetchCoupons }, dispatch);

const mapStateToProps = state => {
	return {
		userIsConnected: isAuthenticated(state),
		brand: state.brand.code,
		enableSponsorship: state.partner.enableSponsorship,
		enableCredits: state.partner.enableCredits,
		enableCreditNotes: state.partner.enableCreditNotes,
		partnerCode: state.partner.code,
		totalCredit: getAvailableCreditsTotal(state),
		totalCreditNote: getAvailableCreditNotesTotal(state),
		shouldDisplayCreditNotesEntry: hasAnyCreditNotes(state),
		myBookingsCustomerRequestCount: getMyBookingsCustomerRequestsCount(state),
		showSmartDPOnRootUrl: state.partner.showSmartDPOnRootUrl,
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AccountAsideMenuAuthenticatedContainer);
